import { Renderer2, RendererStyleFlags2 } from '@angular/core';

export class ElementStyler {
    private _classes: string[] = [];
    private _styles: { style: string; value: string }[] = [];

    constructor(private _el: HTMLElement, private _renderer: Renderer2) {}

    addClass(className: string): void {
        this._classes.push(className);
        this._renderer.addClass(this._el, className);
    }

    removeClass(className: string): void {
        this._classes = this._classes.filter((item) => item !== className);

        this._renderer.removeClass(this._el, className);
    }

    clearClasses(): void {
        this._classes.forEach((x: string) => this.removeClass(x));
    }

    setStyle(style: string, value: string, dashCase = false): void {
        const dashFlag = dashCase ? RendererStyleFlags2.DashCase : undefined;

        this._styles.push({ style: style, value: value });
        this._renderer.setStyle(this._el, style, value, dashFlag);
    }

    removeStyle(style: string): void {
        this._styles = this._styles.filter((item) => item.style !== style);

        this._renderer.removeStyle(this._el, style);
    }

    clearStyles(): void {
        this._styles.forEach((x: { style: string; value: string }) => this.removeStyle(x.style));
    }

    clearAll() {
        this.clearClasses();
        this.clearStyles();
    }
}
